import React from "react";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import LeftCustomMenu from "@layout/MainLayout/MainDrawer/LeftCustomMenu";
import { filterIcons } from "@assets/icons/CustomIcons";
import { NavLink as RouterLink } from "react-router-dom";

const LeftSubNullMenu = ({ data, arr }) => {
  return (
    <ListItem
      button
      component={RouterLink}
      to="/"
      sx={{
        borderRadius: "8px",
        mb: 0.75,
        backgroundColor: arr === "" ? "primary.light" : "",
        "&:hover": {
          backgroundColor: "primary.light",
          color: "primary.main",
          "& svg": {
            fill: "#4183FF",
          },
        },
      }}
    >
      <ListItemIcon>
        {filterIcons("dashboard", {
          color: `${arr === "" ? "primary" : ""}`,
          fontSize: 24,
        })}
      </ListItemIcon>
      <ListItemText
        primary={
          <LeftCustomMenu
            color={arr === "" ? "primary" : ""}
            sx={{
              color: "#424242",
            }}
          >
            {data.name}
          </LeftCustomMenu>
        }
      />
    </ListItem>
  );
};

export default LeftSubNullMenu;
